

































import {Component, Vue} from 'vue-property-decorator';
import {EventBus} from "@/helpers/EventBus";
import { Inject } from 'vue-typedi';
import { StoreService } from '@/services/StoreService';
import { Zone } from '@/model/Zone';
import { ProductService } from '@/services/ProductService';
import { Product } from '@/model/product/Product';
import authentication from '@/configuration/authentication';

@Component
export default class ProductSelectionForm extends Vue {

    private static readonly MIN_SEARCH_LENGTH: number = 3;

    @Inject()
    storeService!: StoreService;

    @Inject()
    productService!: ProductService;

    public allZones: Zone[] = [];
    public zone: Zone = null;

    public allProducts: Product[] = [];

    public searchInput: string = null;

    created() {
        EventBus.$on(EventBus.REFRESH_STORE, this.onRefreshStore);
        this.storeService.refreshStore();
    }

    private onRefreshStore() {
        this.retrieveZones();
        this.retrieveProducts();
        EventBus.$off(EventBus.REFRESH_STORE, this.onRefreshStore);
    }

    private retrieveZones() {
        this.allZones = this.storeService.currentZones.filter(zone => zone.enabled);
    }
    
    public retrieveProducts() {
        if (this.zone == null) {
            this.allProducts = [];
            return;
        }

        this.productService.getProducts(this.zone.zoneCode)
            .then(products => {
                this.allProducts = products;
            });
    }

    public selectProduct(product: Product) {
        if (product == null) {
            return;
        }
        
        this.$emit('selectProduct', product);
    }

    get canSearchProduct(): boolean {
        return this.searchInput != null && this.searchInput.length >= ProductSelectionForm.MIN_SEARCH_LENGTH;
    }

    get filteredProducts(): Product[] {
        if (!this.canSearchProduct) {
            return [];
        }

        const getSearchPositions = (p: Product, searchInput: string) => {
            return {
                positionInCug: p.cug == null ? -1 : p.cug.indexOf(searchInput),
                positionInLabel: p.label == null ? -1 : this.normalizeText(p.label).indexOf(searchInput),
                cug: p.cug == null ? 1000000000 : +p.cug,
                product: p
            };
        };

        const searchInput = this.normalizeText(this.searchInput);

        return this.allProducts
            .filter((p: Product) => p.cug.includes(searchInput) || this.normalizeText(p.label).includes(searchInput))
            .map((p: Product) => getSearchPositions(p, searchInput))
            .sort((a, b) => {
                return (a.positionInCug - b.positionInCug)
                    || (a.positionInLabel - b.positionInLabel)
                    || (a.cug - b.cug)

            })
            .map(sp => sp.product);
    }

    private normalizeText(text: string): string {
        return text?.trim()
                    .toLocaleLowerCase()
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "");
    }

    public startBulkManagement() {
        this.$emit('startBulkManagement');
    }

    public getProductLabel(label: string) {
        return label ? label : 'Libellé indisponible';
    }

    get canDisplayProductSearch() {
        const userRights = authentication.userRights();
        return userRights && 
        (userRights.role === 'CENTRAL_ADMIN' 
        || userRights.role === 'STORE_ADMIN'
        || userRights.role === 'MANAGER');
    }
}
